import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import type { User } from '../types/models';
import type { Notification } from '../components/layout/notifications-constants';
interface DataState {
  _user: User | null;
  notifications: Notification[];
  cart: { id: string; quantity?: number }[];
}

type DataAction =
  | { type: 'SET_USER'; payload: User | null }
  | { type: 'SET_NOTIFICATIONS'; payload: Notification[] }
  | { type: 'SET_CART'; payload: { id: string; quantity?: number }[] };

interface DataContextType {
  state: DataState;
  dispatch: React.Dispatch<DataAction>;
}

const DataContext = createContext<DataContextType | null>(null);

const initialState: DataState = {
  _user: null,
  notifications: [],
  cart: [],
};

const dataReducer = (state: DataState, action: DataAction): DataState => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, _user: action.payload };
    case 'SET_NOTIFICATIONS':
      return { ...state, notifications: action.payload };
    case 'SET_CART':
      return { ...state, cart: action.payload };
    default:
      return state;
  }
};

export const DataProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(dataReducer, initialState);

  return (
    <DataContext.Provider value={{ state, dispatch }}>
      {children}
    </DataContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};
